import React, { useState } from 'react';
import { Select, MenuItem, FormControl, InputLabel, Box, SelectChangeEvent } from '@mui/material';

interface ListSizeSelectorProps {
    values: number[];
    onChange?: (value: number) => void;
}

function ListSizeSelector({ values, onChange }: ListSizeSelectorProps) {
    const [localValues, _setLocalValues] = useState(values);
    const [size, setSize] = useState(values[0]);
    const menuItems = React.useMemo(() => {
        return localValues.map((m) => {
            return <MenuItem key={m.toString()} value={m} >{m}</MenuItem>
        });
    }, [localValues]);

    const handleChange = (event: SelectChangeEvent<number>) => {
        let dataValue = event.target.value as number || values[0];
        if (typeof event.target.value == 'string') {
            dataValue = Number.parseInt(event.target.value) || values[0];
        }
        setSize(dataValue);
        onChange && onChange(dataValue);
    };

    return (
        <Box sx={{ minWidth: 70 }}>
            <FormControl fullWidth>
                <Select
                    labelId="size-select-label"
                    id="size-select"
                    value={size}
                    variant='standard'
                    defaultValue={localValues[0]}
                    onChange={handleChange}
                >
                    {menuItems}
                </Select>
            </FormControl>
        </Box>
    );
}

export default ListSizeSelector;
